import React, { useEffect, useRef, useState } from "react";
import { ArrowDownUp, Check, X } from "lucide-react";
import "./sorting.css";

/** Pulsante ORDINA per le viste a card o lista: menu di criteri con criterio attivo evidenziato. */
export const SortMenu = ({ options, sort, onPick, testId = "sort-menu" }) => {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = event => { if (box.current && !box.current.contains(event.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  const active = sort?.key ? options.find(option => option.key === sort.key && option.dir === sort.dir) : null;
  const groups = [...new Set(options.map(option => option.group))];
  return <div className="sort-menu" ref={box}>
    <button type="button" className={`sort-menu-trigger${active ? " on" : ""}`} data-testid={testId}
      aria-expanded={open} onClick={() => setOpen(!open)}>
      <ArrowDownUp size={14} />
      <span>{active ? `Ordina · ${active.label}` : "Ordina"}</span>
    </button>
    {active && <button type="button" className="sort-menu-clear" title="Torna all'ordinamento predefinito"
      data-testid={`${testId}-clear`} onClick={() => onPick(null)}><X size={13} /></button>}
    {open && <div className="sort-menu-panel" role="menu" data-testid={`${testId}-panel`}>
      {groups.map(group => <div key={group} className="sort-menu-group">
        <span>{group}</span>
        {options.filter(option => option.group === group).map(option => {
          const on = active === option;
          return <button key={`${option.key}-${option.dir}`} type="button" role="menuitemradio" aria-checked={on}
            className={on ? "on" : ""} data-testid={`${testId}-${option.key}-${option.dir}`}
            onClick={() => { onPick({ key: option.key, kind: option.kind, dir: option.dir }); setOpen(false); }}>
            {on ? <Check size={13} /> : <i />}{option.label}
          </button>;
        })}
      </div>)}
    </div>}
  </div>;
};
